var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#fff"}},[_c('a-table',{attrs:{"rowKey":"id","size":"small","columns":_vm.columns,"dataSource":_vm.items,"pagination":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }